import { makeStyles } from '@material-ui/core';
import StandardPopup from 'component/StandardPopup';
import firebaseApp from '../../firebase';
import { useEffect, useState } from 'react';
import { ToastType } from 'constants/toast';
import { STRINGS } from 'constants/strings';

const useStyles = makeStyles(() => ({
    container: {
        width: 250,
    },
    title: {
        fontWeight: 400,
        fontSize: '18px',
        lineHeight: '22px',
        textAlign: 'center',
    },
    content: {
        fontSize: '14px',
        lineHeight: '21px',
        color: '#767676',
        textAlign: 'center',
    },
    list: {
        marginTop: 8,
        marginBottom: 16,
    },
    link: {
        color: 'inherit',
    },
}));

const modalState = {
    button1: 'Okay',
    path: '',
    type: '',
    closeButton: false,
};
export const AppInternetStatusProvider = () => {
    const [modalShow, setModalShow] = useState(false);

    useEffect(() => {
        firebaseApp
            .database()
            .ref('.info/connected')
            .on('value', function (snapshot) {
                if (snapshot.val() === true) {
                    setModalShow(false);
                } else {
                    if (!navigator.onLine) {
                        setModalShow(true);
                    }
                }
            });
    }, []);

    const handleAgree = () => {
        setModalShow(false);
    };
    const classes = useStyles();
    const popupContent = () => {
        return (
            <div className={classes.container}>
                <div>
                    <h1 className={classes.title}>{STRINGS.NO_INTERNET}</h1>
                    <p className={classes.content}>{STRINGS.NO_INTERNET_MESSAGE}</p>
                </div>
            </div>
        );
    };

    return (
        <>
            <StandardPopup
                show={modalShow}
                onHide={() => setModalShow(false)}
                content={popupContent()}
                button1={modalState.button1}
                type={ToastType.Error}
                closeButton={modalState.closeButton}
                onFirstButtonClick={handleAgree}
            />
        </>
    );
};
